import { render, staticRenderFns } from "./ComponentPagination.vue?vue&type=template&id=296dff46&"
import script from "./ComponentPagination.vue?vue&type=script&lang=js&"
export * from "./ComponentPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports